import { SocialUrl, SocialUrlType } from '~api'

interface SplittedSocialUrls {
  website?: SocialUrl
  socialItems: SocialUrl[]
}

export const splitSocialUrls = (socialUrls: SocialUrl[]) =>
  socialUrls.reduce(
    (acc, item) => {
      if (item.type === SocialUrlType.Website) {
        // eslint-disable-next-line no-param-reassign
        acc.website = item
      } else {
        acc.socialItems.push(item)
      }
      return acc
    },
    { socialItems: [] } as SplittedSocialUrls
  )
